module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-item-link"
  }, [(_vm.data.previewImageUrl && _vm.data.mediaType !== 'External') ? _c('div', {
    staticClass: "image-wrapper"
  }, [_c('a', {
    attrs: {
      "href": ("https://www.develteam.com/userdata/media/" + (_vm.data.mediaUrl)),
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": ("https://www.develteam.com/userdata/media/" + (_vm.data.previewImageUrl)),
      "alt": _vm.altText,
      "title": _vm.altText
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.data.previewImageUrl && _vm.data.mediaType === 'External') ? _c('div', {
    staticClass: "image-wrapper"
  }, [_c('a', {
    attrs: {
      "href": _vm.data.mediaUrl,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": ("https://www.develteam.com/userdata/media/" + (_vm.data.previewImageUrl)),
      "alt": _vm.altText,
      "title": _vm.altText
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.data.mediaType === 'Archive') ? _c('span', {
    staticClass: "download"
  }, [_c('a', {
    attrs: {
      "href": ("https://www.develteam.com/userdata/media/" + (_vm.data.mediaUrl)),
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fas fa-download"
  }), _vm._v("Download Archive")])]) : _vm._e(), _vm._v(" "), (_vm.data.mediaType === 'External') ? _c('span', {
    staticClass: "download"
  }, [_c('a', {
    attrs: {
      "href": _vm.data.mediaUrl,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fas fa-external-link-alt"
  }), _vm._v("Visit External Link")])]) : _vm._e(), _vm._v(" "), (_vm.data.mediaType === 'Flash') ? _c('span', {
    staticClass: "download"
  }, [_c('a', {
    attrs: {
      "href": ("https://www.develteam.com/userdata/media/" + (_vm.data.mediaUrl)),
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fas fa-play-circle"
  }), _vm._v("Play Flash Game")])]) : _vm._e(), _vm._v(" "), (_vm.data.mediaType === 'Text') ? _c('span', {
    staticClass: "download"
  }, [_c('a', {
    attrs: {
      "href": ("https://www.develteam.com/userdata/media/" + (_vm.data.mediaUrl)),
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fas fa-download"
  }), _vm._v(" Download Document")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-69ee2eac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/MediaItems/MediaItemLink.vue
// module id = 885
// module chunks = 2